// Situação de adesão ao boleto único na tela de envio do boleto (pedido da Meyryene,
// 14/10/2026). O envio é a hora em que a operação já está falando com o cliente: quem
// ainda não aderiu recebe ali uma abordagem humana convidando para a adesão.
//
// Só a UC elegível ganha selo. UC de empresa parceira (a Gran tem boleto único próprio),
// cancelada ou pausada não entra na conversa — mostrar "não aderiu" para elas mandaria a
// operação oferecer algo que o cliente nem pode aceitar.

import { SITUACOES_ELEGIVEIS } from './debitoAutomaticoEquatorial.ts';

export type AdesaoNoEnvio = 'aderiu' | 'aceitou_aguardando' | 'nao_aderiu';

export interface UcAdesaoNoEnvio {
  situacao?: string | null;
  empresa_parceira_id?: string | number | null;
  boleto_unico?: boolean | null;
  boleto_unico_aceite_em?: string | null;
}

/** `null` quando a UC não é elegível ao boleto único — aí não há selo. */
export function adesaoNoEnvio(uc: UcAdesaoNoEnvio | null | undefined): AdesaoNoEnvio | null {
  if (!uc) return null;
  if (uc.empresa_parceira_id) return null;
  // Já liberada vale mesmo que a situação tenha mudado depois: o boleto sai unificado.
  if (uc.boleto_unico === true) return 'aderiu';
  if (!SITUACOES_ELEGIVEIS.has(String(uc.situacao ?? '').trim())) return null;
  // Aceitou e não foi liberada: hoje a única trava é débito automático na Equatorial.
  if (uc.boleto_unico_aceite_em) return 'aceitou_aguardando';
  return 'nao_aderiu';
}

export const ROTULOS_ADESAO_NO_ENVIO: Record<AdesaoNoEnvio, { texto: string; ajuda: string }> = {
  aderiu: {
    texto: 'Aderiu ao boleto único',
    ajuda: 'O cliente já paga Vigor e Equatorial num boleto só.',
  },
  aceitou_aguardando: {
    texto: 'Aceitou, aguardando liberação',
    ajuda: 'Aceitou no Portal, mas tem débito automático da conta de luz no banco. Ele precisa cancelar o débito para a unidade ser liberada.',
  },
  nao_aderiu: {
    texto: 'Não aderiu ao boleto único',
    ajuda: 'Oportunidade: ofereça a adesão nesta conversa. Depois, mande o convite com o passo a passo.',
  },
};

export const URL_PORTAL_CONSUMIDOR = 'https://hub.vigorenergy.com.br/#/portal-consumidor';

/**
 * Mensagem que a operação cola no WhatsApp depois da conversa. A senha inicial do Portal
 * é o começo do CPF — o piloto de 24/09/2026 mostrou que, sem dizer isso, o cliente
 * para no login e não chega ao aceite.
 */
export function textoConviteAdesao(nomeCliente?: string | null): string {
  const primeiro = String(nomeCliente ?? '').trim().split(/\s+/)[0] || '';
  const nome = primeiro ? primeiro[0].toUpperCase() + primeiro.slice(1).toLowerCase() : '';
  return [
    `${nome ? `Olá, ${nome}!` : 'Olá!'} Para aderir ao boleto único e pagar a energia da Vigor e a conta da Equatorial num pagamento só:`,
    '',
    `1. Acesse ${URL_PORTAL_CONSUMIDOR}`,
    '2. Entre com o seu CPF (ou CNPJ). A senha são os 6 primeiros números do documento.',
    '3. O convite do boleto único aparece logo na entrada: leia as condições até o fim, marque a sua unidade e clique em aceitar.',
    '',
    'Importante: se a sua conta de luz está em débito automático ou Pix automático no banco, cancele antes de aderir, para não pagar duas vezes.',
  ].join('\n');
}
